import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, RejectSetupDialogueHandler } from '../types';
import RejectSetupContext from './RejectSetupContext';
import { usePaylink } from '../../../providers/Paylink.provider';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type RejectSetupDialogueProps = {
  handleDialogue: DialogueHandler<RejectSetupDialogueHandler>;
};

type FC = FunctionComponent<RejectSetupDialogueProps>;

const RejectSetupDialogue: FC = ({ handleDialogue }: RejectSetupDialogueProps) => {
  const { showRejectSetupConfirmationAlert } = useContext(RejectSetupContext);
  const { paylink } = usePaylink();
  const { t } = useTranslation('translations', { keyPrefix: 'Welcome.RejectDialog' });
  return useMemo(
    () => (
      <div>
        {/* User Reject Setup Confirmation */}
        <ConfirmationDialogue
          isVisible={showRejectSetupConfirmationAlert}
          title={t('title', { defaultValue: 'Are you sure to want to decline the operation?' })}
          variant="paylink"
          status="paylinkAlert"
          subTitle={t('subTitle', {
            senderName: paylink.SenderName,
            defaultValue: 'The {{senderName}} will be notified that you have declined the operation.',
          })}
          buttonColor="primary"
          confirm={{
            label: t('yesButton', { defaultValue: 'Yes' }),
            action: () => handleDialogue({ type: 'reject', state: 'yes' }),
          }}
          cancel={{
            label: t('noButton', { defaultValue: 'No' }),
            action: () => handleDialogue({ type: 'reject', state: 'no' }),
          }}
        />
      </div>
    ),
    [showRejectSetupConfirmationAlert],
  );
};

export default RejectSetupDialogue;
